import { render } from "./MsTabDynamic.vue?vue&type=template&id=80b16f9c&scoped=true"
import script from "./MsTabDynamic.vue?vue&type=script&lang=js"
export * from "./MsTabDynamic.vue?vue&type=script&lang=js"

import "./MsTabDynamic.vue?vue&type=style&index=0&id=80b16f9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b16f9c"]])

export default __exports__